var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuBurg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57143 7.57143H19.4286C19.7143 7.57143 20 7.32143 20 7V5.57143C20 5.28571 19.7143 5 19.4286 5H4.57143C4.25 5 4 5.28571 4 5.57143V7C4 7.32143 4.25 7.57143 4.57143 7.57143ZM4.57143 13.2857H19.4286C19.7143 13.2857 20 13.0357 20 12.7143V11.2857C20 11 19.7143 10.7143 19.4286 10.7143H4.57143C4.25 10.7143 4 11 4 11.2857V12.7143C4 13.0357 4.25 13.2857 4.57143 13.2857ZM4.57143 19H19.4286C19.7143 19 20 18.75 20 18.4286V17C20 16.7143 19.7143 16.4286 19.4286 16.4286H4.57143C4.25 16.4286 4 16.7143 4 17V18.4286C4 18.75 4.25 19 4.57143 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurg);
export default __webpack_public_path__ + "static/media/menu-burg.7b7ff73cd715fe1d79d1f1b053fb14a6.svg";
export { ForwardRef as ReactComponent };